export default __webpack_public_path__ + "static/media/12-TheDubaiMall-Logo.ba05bd69.jpg";